import * as Sentry from '@sentry/browser';
import ReactDOM from 'react-dom/client';

import App from './app';

const settings = window.catalogue.settings;
const dsn = settings.raven ? settings.raven.dsn : null;
if (dsn !== '') {
    Sentry.init({ dsn: dsn });
}

const mountNode = document.getElementById('app');
const root = ReactDOM.createRoot(mountNode);
root.render(<App />);
